const updates = [
  { time: '10分钟前', title: '某男团队长深夜发文回应恋情传闻，粉丝评论区炸锅', tag: '音乐', hot: true },
  { time: '28分钟前', title: '热门都市剧大结局收视率破纪录，片方宣布将拍续集', tag: '影视', hot: true },
  { time: '42分钟前', title: '知名导演新片开机仪式现场，豪华演员阵容曝光', tag: '影视', hot: false },
  { time: '1小时前', title: '短视频平台两大头部主播隔空互怼引百万围观', tag: '网红', hot: true },
  { time: '1小时前', title: '一线女星官宣代言国际奢侈品牌，广告大片释出', tag: '时尚', hot: false },
  { time: '2小时前', title: '综艺天王透露即将退出主持界，网友集体挽留', tag: '综艺', hot: true },
  { time: '2小时前', title: '年度音乐颁奖礼提名名单公布，新生代歌手占半壁江山', tag: '音乐', hot: false },
  { time: '3小时前', title: '人气偶像团体宣布亚洲巡演日程，中国站日期引发抢票热潮', tag: '演出', hot: true },
  { time: '3小时前', title: '经典IP翻拍消息确认，原著粉丝态度两极分化激烈讨论', tag: '影视', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          实时瓜情快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">滚动更新最新娱乐动态与热点事件</p>
        <div className="space-y-0">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200/50 last:border-b-0 cursor-pointer hover:bg-background-50/50 px-3 -mx-3 rounded transition-colors"
            >
              <div className="flex-shrink-0 mt-0.5">
                <div className={`w-2.5 h-2.5 rounded-full ${item.hot ? 'bg-primary-500 animate-pulse' : 'bg-secondary-300'}`}></div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 leading-snug">{item.title}</h3>
              </div>
              <span className="flex-shrink-0 px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded whitespace-nowrap">
                {item.tag}
              </span>
              <span className="flex-shrink-0 text-xs text-foreground-400 whitespace-nowrap w-16 text-right">
                {item.time}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}